import { motion, useReducedMotion } from "framer-motion"
import type { BaseAnimationProps } from "./types"

interface FadeFromTopProps extends BaseAnimationProps {
  y?: number
}

const FadeFromTop = ({
  children,
  style,
  delay = 0,
  className,
  y = -20,
}: FadeFromTopProps) => {
  const shouldReduceMotion = useReducedMotion()

  return (
    <motion.div
      className={className}
      style={style}
      initial={{ opacity: 0, y: y }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        delay: shouldReduceMotion ? 0 : delay,
        y: {
          type: "spring",
          duration: 0.3,
          delay: shouldReduceMotion ? 0 : delay,
        },
      }}
    >
      {children}
    </motion.div>
  )
}

export default FadeFromTop
